import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../Components/Login/Login";
import { useSelector } from "react-redux";
const RootRoute = () => {
  return (
   <>
     <Routes>
      <Route path="/" element={<Login />} />
      <Route path="*" element={null} />
    </Routes>

   </>
  );
};

export default RootRoute;
